import React, { useContext } from "react";
import { useReducer } from "react";

export interface MaxCanvasSizes {
  maxCanvasAreaSqrt: number;
  maxCanvasHeight: number;
  maxCanvasWidth: number;
}

interface StoreState {
  sizes: MaxCanvasSizes;
}

const initialState = {
  sizes: {
    maxCanvasAreaSqrt: 0,
    maxCanvasHeight: 0,
    maxCanvasWidth: 0,
  },
} as const satisfies StoreState;

interface Action {
  type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  detail: any;
}

export const StoreContext = React.createContext<{
  state: StoreState;
  dispatch: (action: Action) => void;
}>({
  state: initialState,
  dispatch: () => {
    throw new Error("No store provider found");
  },
});

interface StoreProviderProps {
  children?: React.ReactNode;
}

export const useStore = () => {
  return useContext(StoreContext);
};

const StoreProvider: React.FC<StoreProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer((state: StoreState, action: Action) => {
    switch (action.type) {
      case "setCanvasSize": {
        return { ...state, sizes: action.detail };
      }
      default: {
        throw new Error("Unknown action type dispatched");
      }
    }
  }, initialState);

  return <StoreContext.Provider value={{ state, dispatch }}>{children}</StoreContext.Provider>;
};

export default StoreProvider;
